// Shared data-shape for the Analytics tab's inventory (Overview cards +
// rail badge). Each slice is `null` when its fetch failed / the feature is
// unavailable, so the UI can degrade per-card instead of failing the tab.
import type { BiConnection } from '@/api/connections'
import type {
  BusinessAreaSummary, CatalogObject, ProjectPageSummary, ProjectReportSummary,
  VisualSchemaSummary,
} from '@/api/designers'
import type { ForesightSummary } from '@/api/foresight'
import type { ProjectProcessSummary } from '@/api/genprocess'
import type { StandardizeRequestList } from '@/api/standardize'

// One slice per object type the tab has a rail section for — Overview shows a
// card for each, so a type with a section can never be missing from the counts.
export interface AnalyticsInventory {
  connections: BiConnection[] | null
  areas: BusinessAreaSummary[] | null
  schemas: VisualSchemaSummary[] | null
  visuals: CatalogObject[] | null
  dashboards: CatalogObject[] | null
  reports: ProjectReportSummary[] | null
  processes: ProjectProcessSummary[] | null
  pages: ProjectPageSummary[] | null
  foresight: ForesightSummary[] | null
  /** null ⇒ standardization backend unavailable — hide the queue everywhere. */
  standardize: StandardizeRequestList | null
}

export const EMPTY_INVENTORY: AnalyticsInventory = {
  connections: null,
  areas: null,
  schemas: null,
  visuals: null,
  dashboards: null,
  reports: null,
  processes: null,
  pages: null,
  foresight: null,
  standardize: null,
}
